import { React, useEffect, useState } from "react";
import { Row, Col, Form, Button, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { useGetGymsQuery } from "../slices/adminSlice";
import {
  getCurrentDate,
  getCurrentTime,
  getDateOfLast,
} from "../utils/getCurrentDate";
import { setCredentials } from "../slices/authSlice";
import { openWhatsApp } from "../utils/generalUtilities";
import { IoLogoWhatsapp } from "react-icons/io";

const PendingPaymentsScreen = () => {
  const [searchBy, setSearchBy] = useState("Gym Id");
  const [searchValue, setSearchValue] = useState("");
  const { userInfo } = useSelector((state) => state.auth);
  const [startDate, setStartDate] = useState("2024-01-01");

  const [endDate, setEndDate] = useState(getCurrentDate());

  const [getApiQuery, setGetApiQuery] = useState(
    `subsExpiryDate[gte]=${getCurrentDate()}&dueAmount[gt]=0&fields=_id,name,primaryContact,subsAmount,paidAmount,dueAmount,subsRenewedDate`
  );

  const filterOptions = ["Gym Id", "Txn Id"];

  const dispatch = useDispatch();

  const searchOptions = {
    "Gym Id": "gymId",
    "Txn Id": "transactionId",
  };
  let {
    data: allGyms,
    isLoading,
    refetch,
    error,
  } = useGetGymsQuery({
    token: userInfo?.token,
    query: getApiQuery,
  });

  const [totalPendings, setTotalPendings] = useState(
    isLoading ? [] : allGyms?.gyms ? allGyms?.gyms : []
  );
  const [pendingsToList, setPendingsToList] = useState(
    isLoading ? [] : allGyms?.gyms ? allGyms?.gyms : []
  );

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    setTotalPendings(isLoading ? [] : allGyms?.gyms ? allGyms?.gyms : 0);
    setPendingsToList(isLoading ? [] : allGyms?.gyms ? allGyms?.gyms : 0);
  }, [isLoading, allGyms]);

  const handleSelect = (e) => {
    setSearchBy(e.target.value);
  };
  const onSearchTextChange = (val) => {
    setSearchValue(val);
    const searchedUsers = allGyms?.filter((user) => {
      let userData;
      if (searchBy === "Txn Id") {
        userData = String(user[searchOptions[searchBy]]).toLowerCase();
      } else {
        userData = String(user[searchOptions[searchBy]]);
      }
      return userData.includes(val.toLowerCase());
    });
    setPendingsToList(searchedUsers);
  };

  const handleFilterSelecttion = (val) => {
    setPendingsToList(val);
  };

  const handleGetUsers = async () => {
    if (startDate > getCurrentDate())
      toast.error("Start date can not be greater than today");
    else if (startDate > endDate)
      toast.error("Start date can not be greater than End date");
    else {
      if (endDate?.split("T")[0] > getCurrentDate())
        setEndDate(getCurrentDate() + getCurrentTime());
      setGetApiQuery(
        `subsRenewedDate[gte]=${startDate}&subsRenewedDate[lte]=${endDate}T23:59:59.000Z&dueAmount[gt]=0
        &fields=_id,name,primaryContact,subsAmount,paidAmount,dueAmount,subsRenewedDate`
      );
      dispatch(
        setCredentials({
          ...userInfo,
          paymentStartDate: startDate,
          paymentEndDate: endDate,
        })
      );
    }
  };

  const navigate = useNavigate();
  const handlePayNow = async (customer) => {
    navigate("/payNow", {
      state: { gymDetails: customer },
    });
  };

  return (
    <>
      <label>
        <strong>Pending Payments List</strong>
      </label>
      <Row
        className="mb-1"
        style={{
          justifyContent: "center",
          margin: "auto",
          width: "95%",
          alignItems: "center",
        }}
      >
        <Col xs={6} md="auto" sm={6}>
          <Form.Group controlId="visitorMobile">
            <Form.Control
              type="date"
              placeholder="2023-11-23"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            ></Form.Control>{" "}
          </Form.Group>
        </Col>
        <Col xs={6} md="auto" sm={6}>
          <Form.Group controlId="visitorMobile">
            <Form.Control
              type="date"
              placeholder="2023-11-27"
              value={endDate?.split("T")[0]}
              onChange={(e) => setEndDate(e.target.value)}
            ></Form.Control>{" "}
          </Form.Group>
        </Col>
        <Col xs={12} md="auto" sm={6} className="d-flex justify-content-center">
          <Form.Group className="my-1" controlId="gymType">
            <Button onClick={handleGetUsers}>Get Data</Button>
          </Form.Group>
        </Col>
      </Row>

      {/* <Row
        className="mb-3"
        style={{
          justifyContent: "center",
          padding: "auto",
          margin: "auto",
          width: "95%",
          alignItems: "center",
        }}
      >
        <Col>
          <Form.Group as={Row} className="my-2" controlId="filterBy">
            <Form.Select id="filterBy" value={searchBy} onChange={handleSelect}>
              {filterOptions.map((e) => (
                <option key={e} value={e}>
                  {e}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group as={Row} className="my-2" controlId="visitorMobile">
            <Form.Control
              type="text"
              placeholder="type here to search"
              value={searchValue}
              onChange={(e) => onSearchTextChange(e.target.value)}
            ></Form.Control>
          </Form.Group>
        </Col>
        <Col>
          <Form.Group as={Row} className="my-2" controlId="visitorMobile">
            <Button
              type="date"
              placeholder="2023-11-27"
              value={searchValue}
              onChange={(e) => onSearchTextChange(e.target.value)}
            >
              Search
            </Button>
          </Form.Group>
        </Col>
      </Row> */}
      <Row
        className="dataRow"
        style={{
          margin: "1rem",
          color: "green",
          justifyContent: "center",
        }}
      >
        <span style={{ marginRight: "1rem", width: "fit-content" }}>
          <strong> Count : {totalPendings?.length}</strong>
        </span>
        <span style={{ marginRight: "1rem", width: "fit-content" }}>
          <strong>
            {" "}
            Amount{" : "}{" "}
            {totalPendings?.length > 0 &&
              totalPendings?.reduce((accumulator, obj) => {
                return accumulator + obj.dueAmount;
              }, 0)}
          </strong>
        </span>
      </Row>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message>{error.data.error}</Message>
      ) : (
        <div>
          <Table striped bordered hover responsive="sm">
            <thead>
              <tr key="table-header">
                <th>Gym Id</th>
                <th>Gym Name</th>
                <th>Mobile</th>
                <th>Subs Amount</th>
                <th>Paid Amount</th>
                <th>Pending Amount</th>
                <th>Subs Date</th>
              </tr>
            </thead>
            {pendingsToList ? (
              <tbody>
                {pendingsToList.map((gym) => (
                  <tr key={gym._id}>
                    <td>{gym._id}</td>
                    <td>{gym.name}</td>
                    <td>{gym.primaryContact}</td>
                    <td style={{ whiteSpace: "nowrap" }}>{gym.subsAmount}</td>
                    <td> {gym.paidAmount}</td>

                    <td style={{ color: "red" }}>
                      {gym.dueAmount}{" "}
                      <small
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        onClick={(e) => handlePayNow(gym)}
                      >
                        Pay Now
                      </small>
                      <button
                        style={{
                          border: "none",
                          color: "green",
                          background: "transparent",
                          padding: "0px",
                          cursor: "pointer",
                          margin: "0px",
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={(e) =>
                          openWhatsApp(
                            gym.primaryContact,
                            "pendingPaymentsMessage",
                            gym.dueAmount,
                            "",
                            gym.name
                          )
                        }
                      >
                        <IoLogoWhatsapp />
                      </button>
                    </td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      {" "}
                      {new Date(
                        new Date(gym?.subsRenewedDate).getTime() +
                          1000 * 60 * 60 * 5.5
                      )
                        .toISOString()
                        .toString()
                        .split("T")[0]
                        .slice(0, 16)}
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <Message>No users Available</Message>
            )}
          </Table>
        </div>
      )}
    </>
  );
};

export default PendingPaymentsScreen;
